import logger from '../../../../library/Core/logger';
import { axiosClient } from '../../../../library/Service/axiosClient';

class RecruiterDashboardService {
    static pageLoader(params: any) {
        const state: any = {};
        const { id, pageName } = params;
        const schoolId = parseInt(sessionStorage.getItem('user-school-id') as string);
        const schoolGroupId = parseInt(sessionStorage.getItem('user-school-group-id') as string) ?? schoolId * -1;

        return Promise.all([RecruiterDashboardService.getBatches(),RecruiterDashboardService.getPrograms()])
            .then((values) => {
                state.formConfig = {};
                state.data = {
                    selectedTab: 'ALUMNI',
                    searchCriteria: {
                        onboarding: {
                            userTypeCode: 'ALUMNI',
                        },
                        occupation: {
                            userTypeCode: 'ALUMNI'
                        },
                        country: {
                            userTypeCode: 'ALUMNI'
                        },
                        topbatches: {
                            userTypeCode: 'ALUMNI',
                        },
                    },
                    isDownloading: false,
                    schoolId,
                    schoolGroupId,
                    batches: values[0].data,
                    programs: values[1].data,
                    accordionState: 'EXPANDED',
                    campuses: [],
                    reportData: {},
                    dashboardData: {},
                    onboarding_isOpen: true,
                    topbatches_isOpen: true,
                    occupation_isOpen: true,
                    country_isOpen: true,
                };

                state.routeInfo = { id, pageName };
                return Promise.resolve(state);
            })
            .catch(function (err) {
                logger.log(`Error in loading data for ${pageName} and the error is:`);
                console.log(err);
            });
    }

    static get(schoolId: number, schoolGroupId: number) {
        return axiosClient().post(`${process.env.REACT_APP_STUDENT_MANAGEMENT_SERVER}/dashboard/reports`, {
            schoolId,
            schoolGroupId,
        });
    }

    static getBatches = async () => {
        return axiosClient().get(`${process.env.REACT_APP_STUDENT_MANAGEMENT_SERVER}/dashboard/batches`);
    };

    static getPrograms = async () => {
        return axiosClient().get(`${process.env.REACT_APP_STUDENT_MANAGEMENT_SERVER}/dashboard/programs`);
    };

    // Get batches for a school. Current year and 4 years from that
    // static getBatchesForSelectedTab = (selectedTab: string, batches: any) => {
    //     return selectedTab === 'ALUMNI'
    //         ? RecruiterDashboardService.getBatchesForAlumni(batches)
    //         : RecruiterDashboardService.getBatchesForStudent();
    // };

    static getBatchesForSelectedTab = (selectedTab: string, batches: any) => {
        const uniqueLabels = new Set();
        const uniqueBatches = batches.filter((batch: any) => {
            if (!uniqueLabels.has(batch.label) && batch.userTypeCode === selectedTab) {
                uniqueLabels.add(batch.label);
                return true;
            }
            return false;
        });
        return uniqueBatches.map((batch: any) => ({ label: batch.label, value: batch.value }));
    };

    static getProgramsForSelectedTab = (selectedTab: string, programs: any) => {
        const uniqueLabels = new Set();
        const uniqueprograms = programs.filter((program: any) => {
            if (!uniqueLabels.has(program.label) && program.userTypeCode === selectedTab) {
                uniqueLabels.add(program.label);
                return true;
            }
            return false;
        });
        return uniqueprograms.map((program: any) => ({ label: program.label, value: program.value }));
    };

    static getBatchesForStudent = () => {
        const currentYear = new Date().getFullYear();
        const batches = [];
        // @AGS-556-start @dt 20th.Sep,2K23 @by RG @note for 8th class students,
        // passout year will be current year + 5
        // for (let i = 0; i < 5; i++) {
        for (let i = 0; i < 6; i++) {
            const year = currentYear + i;
            const row: any = { label: year, value: year };
            batches.push(row);
        }
        return batches;
    };

    static getBatchesForAlumni = (batches: any) => {
        const uniqueLabels = new Set();
        const uniqueBatches = batches.filter((batch: any) => {
            if (!uniqueLabels.has(batch.label) && batch.userTypeCode === 'ALUMNI') {
                uniqueLabels.add(batch.label);
                return true;
            }
            return false;
        });
        return uniqueBatches.map((batch: any) => ({ label: batch.label, value: batch.value }));
    };

    static getCampusForSelectedTab = (state: any, config: any) => {
        if (state.selectedTab === 'STUDENT') return state.campuses;

        // Alumni
        const selectedBatch = state.searchCriteria[config.key].batch;
        if (!selectedBatch) return state.campuses;
        const filteredSchoolId = state.batches
            .filter((batch: any) => batch.userTypeCode === 'ALUMNI' && selectedBatch.split(',').includes(batch?.value?.toString()))
            ?.map((batch: any) => batch?.schoolId);
        return state.campuses.filter((campus: any) => filteredSchoolId.includes(parseInt(campus.value)));
    };

    static config: any = {
        ONBOARDING: {
            key: 'onboarding',
            title: 'Onboarding Funnel',
            tab: 'STUDENT',
            filters: ['userTypeCode', 'programName', 'batch', 'campus'],
        },
        TOPBATCHES: {
            key: 'topbatches',
            title: 'Top Batches',
            tab: 'STUDENT',
            filters: ['userTypeCode', 'programName', 'campus'],
        },
        OCCUPATION: {
            key: 'occupation',
            title: 'Alumni Occupation',
            tab: 'ALUMNI',
            filters: ['programName', 'batch', 'campus'],
        },
        COUNTRY: {
            key: 'country',
            title: 'Current Location',
            tab: 'ALUMNI',
            filters: ['userTypeCode', 'programName', 'batch', 'campus'],
        },
    };
}

export default RecruiterDashboardService;
